import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  atributos: [],
  fetchAtributosLoading: false,
  fetchAtributosError: null,

  addAtributoLoading: false,
  addAtributoError: null,

  updateAtributoLoading: false,
  aupdateAtributoError: null
};

export const atributosSlice = createSlice({
  name: 'ATRIBUTOS',
  initialState,
  reducers: {
    fetchAtributosStart: state => {
      state.fetchAtributosLoading = true;
      state.fetchAtributosError = null;
    },
    fetchAtributosSuccess: (state, action) => {
      state.fetchAtributosLoading = false;
      state.atributos = action.payload;
    },
    fetchAtributosError: (state, action) => {
      state.fetchAtributosLoading = false;
      state.fetchAtributosError = action.payload;
    },

    addAtributoStart: state => {
      state.addAtributoLoading = true;
      state.addAtributoError = null;
    },
    addAtributoSuccess: (state, action) => {
      state.atributos.unshift(action.payload);
      state.addAtributoLoading = false;
    },
    addAtributoError: (state, action) => {
      state.addAtributoLoading = false;
      state.addAtributoError = action.payload;
    },

    updateAtributoStart: state => {
      state.updateAtributoLoading = true;
      state.updateAtributoError = null;
    },
    updateAtributoSuccess: (state, action) => {
      const newData = state.atributos.map(atributo => {
        if (atributo.id === action.payload.id) return action.payload;
        return atributo;
      });
      state.atributos = newData;
      state.updateAtributoLoading = false;
    },
    updateAtributoError: (state, action) => {
      state.updateAtributoLoading = false;
      state.updateAtributoError = action.payload;
    }
  }
});

export const {
  fetchAtributosStart,
  fetchAtributosSuccess,
  fetchAtributosError,
  addAtributoStart,
  addAtributoSuccess,
  addAtributoError,
  updateAtributoStart,
  updateAtributoSuccess,
  updateAtributoError
} = atributosSlice.actions;

export default atributosSlice.reducer;
